export function useViewSectionsHandler() {
    const gtm = useGtm();
    const reservableListFired = ref(false);
    const onViewPromotedList = () => {
        gtm?.trackEvent({
            event: 'view-promoted-cards',
        });
    };
    const onViewReservableList = () => {
        reservableListFired.value = true;
        gtm?.trackEvent({ event: 'view_item_list' });
        gtm?.trackEvent({
            event: 'view-reservable-cards',
        });
    };
    const onViewNonReservableList = () => {
        if (!reservableListFired.value) {
            gtm?.trackEvent({
                event: 'view-none-reservable-cards',
            });
        }
    };
    return {
        onViewPromotedList,
        onViewReservableList,
        onViewNonReservableList,
    };
}
